// src/components/FeedbackComponent.js

import React from 'react';
import './FeedbackComponent.css'; // Optional for styling

const FeedbackComponent = () => {
  
  const handleFeedbackClick = () => {
    window.open("https://docs.google.com/forms/d/e/1FAIpQLSf7WebxWN_RnO_hGBWA-SWeCzTgDtsFtQuq3cxMbACACCzomw/viewform?usp=sf_link", "_blank");
  };
  
  return (
    <div className="feedback-component-container">
        <button 
          className="feedback-button"
          onClick={handleFeedbackClick}>
            
          Send Feedback
        </button>
    </div>
  );
};

export default FeedbackComponent;
